// extracted by mini-css-extract-plugin
export default {"container":"AR-z","dimension":"BR-z","dimensionLabels":"CR-z"};